<template>
    <button v-if="!$page.props.is_production" class="whitespace-nowrap w-full pl-0 text-xs mx-0 button-color RemovButton text-white font-bold w-full mb-0 py-2 text-center" @click="removeFromCart">
                &nbsp;<i
                  class="fa fa-minus-circle plus-font-size"
                  aria-hidden="true"
                ></i>
                &nbsp;REMOVE FOOD ORDER
    </button>
</template>

<script>
  export default {

    props:['cartId'],

    // props : ['cartId'],
    methods: {

        // loadCalendar(){
        //     this.$emit('loadCalendar');
        // },
        loadAlreadyAddedCartData(){
            this.$emit('loadAlreadyAddedCartData');
        },

        async removeFromCart() {
            console.log('cartId: '+ this.cartId);
            try {
                const response = await axios.post('remove-food-order-from-cart', {
                // Request payload or data
                cartId: this.cartId,
                });
               console.log(response.data.message); // Handle the response data as per your requirement

                if(response.data.message == 'success'){
                    // this.showRemoveButton = false;
                    // console.log('sssssss');
                   this.loadAlreadyAddedCartData();
                }
            //    console.log(response.data); // Handle the response data as per your requirement
            } catch (error) {
                console.error(error);
            }
        }
    }
  };
</script>
<style>
.RemovButton{
    background-color: #e7110c !important;
}
/* .button-color{
    background-color: #ff2c27 !important;
} */
</style>
